class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector("details");
    this.content =
      this.mainDetailsToggle.querySelector("summary").nextElementSibling;

    // this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener("toggle", this.onToggle.bind(this));
  }

  // onFocusOut() {
  //   setTimeout(() => {
  //     if (!this.contains(document.activeElement)) this.close();
  //   });
  // }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute("open")) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  // close() {
  //   this.mainDetailsToggle.removeAttribute("open");
  //   this.mainDetailsToggle
  //     .querySelector("summary")
  //     .setAttribute("aria-expanded", false);
  // }
}

customElements.define("details-disclosure", DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  static allMenus = [];
  static activeMenu = null;

  constructor() {
    super();
    this.header = document.querySelector(".header-wrapper");
    this.summary = this.querySelector("summary");
    this.closeTimeout = null;
    this.hoverDelay = 150;

    HeaderMenu.allMenus.push(this);

    this.setupHoverBehavior();
    this.setupKeyboardBehavior();
    this.setupFocusBehavior();
  }

  setupHoverBehavior() {
    if (window.matchMedia("(hover: hover)").matches) {
      this.addEventListener("mouseenter", this.onMouseEnter.bind(this));
      this.addEventListener("mouseleave", this.onMouseLeave.bind(this));

      this.summary?.addEventListener("click", (e) => {
        if (window.innerWidth >= 990) {
          const link = this.summary.querySelector("a");
          if (link && link.getAttribute("href") !== "#") {
            return;
          }
          e.preventDefault();
        }
      });
    }
  }

  setupKeyboardBehavior() {
    this.addEventListener("keydown", (e) => {
      if (e.key === "Escape" && this.mainDetailsToggle.open) {
        e.preventDefault();
        this.close();
        this.summary?.focus();
      }
    });
  }

  setupFocusBehavior() {
    this.addEventListener("focusout", () => {
      setTimeout(() => {
        if (!this.contains(document.activeElement) && this.mainDetailsToggle.open) {
          this.close();
        }
      }, 0);
    });
  }

  onMouseEnter() {
    if (window.innerWidth < 990) return;

    if (this.closeTimeout) {
      clearTimeout(this.closeTimeout);
      this.closeTimeout = null;
    }

    // Close other open menus
    HeaderMenu.allMenus.forEach(menu => {
      if (menu !== this && menu.mainDetailsToggle.open) {
        menu.close();
      }
    });

    HeaderMenu.activeMenu = this;
    this.open();
  }

  onMouseLeave() {
    if (window.innerWidth < 990) return;

    this.closeTimeout = setTimeout(() => {
      if (HeaderMenu.activeMenu === this) {
        HeaderMenu.activeMenu = null;
      }
      this.close();
    }, this.hoverDelay);
  }

  open() {
    this.mainDetailsToggle.setAttribute("open", "");
    this.summary?.setAttribute("aria-expanded", "true");
  }

  close() {
    this.mainDetailsToggle.removeAttribute("open");
    this.summary?.setAttribute("aria-expanded", "false");
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;
    if (this.mainDetailsToggle.hasAttribute("open")) {
      this.summary?.setAttribute("aria-expanded", "true");
    } else {
      this.summary?.setAttribute("aria-expanded", "false");
    }

    if (
      document.documentElement.style.getPropertyValue(
        "--header-bottom-position-desktop"
      ) !== ""
    )
      return;
    document.documentElement.style.setProperty(
      "--header-bottom-position-desktop",
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define("header-menu", HeaderMenu);
